import { render } from "./RowdyDetails.vue?vue&type=template&id=5d962971&scoped=true"
import script from "./RowdyDetails.vue?vue&type=script&lang=js"
export * from "./RowdyDetails.vue?vue&type=script&lang=js"

import "./RowdyDetails.vue?vue&type=style&index=0&id=5d962971&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d962971"]])

export default __exports__